import { useEffect, useState } from "react"

export default function useNavHeight(){
    const [height, setHeight] = useState(null)

    useEffect(() => {
        if (typeof document === 'undefined') return
        setHeight(document.querySelector('#navbar').clientHeight)
    }, [])

    return height
}